<template>
  <div class="card mb-1">
    <div class="card-body p-4 p-md-5">
      <documents-form />
    </div>
  </div>
</template>

<script>
import DocumentsForm from "../components/DocumentsForm";

export default {
  name: "Documents",
  components: {
    DocumentsForm
  },
  mounted() {
    this.$emit("can-continue", { value: true });
  }
};
</script>

<style lang="scss">
.document-form {
  a {
    color: $yellow;
  }
}
</style>
